import { businessSlideTemplates } from './businessSlideTemplates';

const baseTemplates = [
  // BNI Meeting Template - Hidden per user request
  /* {
    id: 'bni-meeting',
    name: 'BNI Meeting Template',
    category: 'Networking',
    description: 'Official BNI chapter meeting presentation',
    theme: 'modern',
    thumbnail: 'https://images.unsplash.com/photo-1556761175-b413da4baf72?w=400&q=80',
    slides: [
      {
        title: 'Leadership Team',
        content: 'President: Name\nVice-President: Name\nTreasurer: Name\nMembership Committee: Name, Name, Name\nVisitor Hosts: Name, Name, Name, Name\nEducation Coordinator: Name\nMentor Coordinator: Name',
        layout: 'bni_white',
        backgroundImage: '',
        backgroundColor: '#ffffff'
      },
      {
        title: 'Our Core Values',
        content: 'Givers Gain®\nBuilding Relationships\nLifelong Learning\nTraditions + Innovation\nPositive Attitude\nAccountability\nRecognition',
        layout: 'bni_white',
        backgroundImage: '',
        backgroundColor: '#ffffff'
      },
      {
        title: 'Purpose & Overview',
        content: 'Presented by\nMember Name',
        layout: 'bni_white',
        backgroundImage: '',
        backgroundColor: '#ffffff'
      },
      {
        title: 'Networking Education',
        content: 'Presented by\nMember Name',
        layout: 'bni_white',
        backgroundImage: '',
        backgroundColor: '#ffffff'
      },
      {
        title: 'Networking Leader Introductions',
        content: 'Most Referrals Given: Name\nMost Visitors: Name\nMost One-to-Ones: Name\nMost TYFCB: Name\nMost CEUs: Name\nPower of One Green: Name, Name, Name, Name, Name, Name, Name, Name',
        layout: 'bni_white',
        backgroundImage: '',
        backgroundColor: '#ffffff'
      },
      {
        title: 'New & Renewing Members',
        content: 'New Members\n<<Names>>\n\nRenewing Members\n<<Names>>',
        layout: 'bni_white',
        backgroundImage: '',
        backgroundColor: '#ffffff'
      },
      {
        title: 'BNI Code Of Ethics',
        content: 'I will provide the quality of services at the prices that I have quoted.\n\nI will be truthful with the members and their referrals.\n\nI will build goodwill and trust among members and their referrals.\n\nI will take responsibility for following up on the referrals I receive.\n\nI will display a positive and supportive attitude with BNI members.\n\nI will live up to the ethical standards of my profession.',
        layout: 'bni_white',
        backgroundImage: '',
        backgroundColor: '#ffffff'
      },
      {
        title: 'Visitor Introductions',
        content: 'Your Name & Company\n\nBriefly Describe What You Do\n\n⏰ 30',
        layout: 'bni_white',
        backgroundImage: '',
        backgroundColor: '#ffffff'
      },
      {
        title: 'Member Weekly Presentations',
        content: 'First Presenter:\nNext Slide\'s Member Name',
        layout: 'bni_white',
        backgroundImage: '',
        backgroundColor: '#ffffff'
      },
      {
        title: 'Weekly Presentation',
        content: 'Name\nBusiness Name\nClassification\nPhone Number\nEmail Address\nWebsite\n\nNext Presenter:\nNext Slide\'s Member Name\n\n⏰ 30',
        layout: 'bni_white',
        backgroundImage: '',
        backgroundColor: '#ffffff'
      },
      {
        title: 'Did We Miss Anyone?',
        content: '?',
        layout: 'bni_white',
        backgroundImage: '',
        backgroundColor: '#ffffff'
      },
      {
        title: 'Vice President\'s Report',
        content: 'Announcements\n\nUpcoming Events\n\nChapter Goals',
        layout: 'bni_white',
        backgroundImage: '',
        backgroundColor: '#ffffff'
      },
      {
        title: 'Thank You Visitors',
        content: 'Please stay on the meeting afterwards for an orientation.',
        layout: 'bni_white',
        backgroundImage: 'https://images.unsplash.com/photo-1556761175-b413da4baf72?w=1920&q=80',
        backgroundColor: '#ffffff'
      },
      {
        title: 'Door Prize Drawing',
        content: 'And the Winner is...',
        layout: 'bni_wheel',
        backgroundImage: '',
        backgroundColor: '#ffffff',
        wheelNames: ['John Smith', 'Sarah Lee', 'Tom Baker', 'Emily White', 'David Chen', 'Lisa Brown', 'Mike Johnson', 'Anna Davis']
      },
      {
        title: 'BNI Announcements',
        content: '',
        layout: 'bni_white',
        backgroundImage: '',
        backgroundColor: '#ffffff'
      },
      {
        title: 'Closing Quote',
        content: '"Insert Quote Of The Day"',
        layout: 'bni_white',
        backgroundImage: '',
        backgroundColor: '#ffffff'
      },
      {
        title: 'Thank You!',
        content: '',
        layout: 'bni_white',
        backgroundImage: '',
        backgroundColor: '#ffffff'
      },
      {
        title: 'Visitor Orientation',
        content: '',
        layout: 'bni_white',
        backgroundImage: 'https://images.unsplash.com/photo-1521737711867-e3b97375f902?w=1920&q=80',
        backgroundColor: '#ffffff'
      },
      {
        title: 'Weekly Referrals Passed',
        content: 'Member Name: X referrals\nMember Name: X referrals\nMember Name: X referrals\nMember Name: X referrals\n\nTotal Referrals This Week: XX',
        layout: 'bni_white',
        backgroundImage: '',
        backgroundColor: '#ffffff'
      },
      {
        title: 'Success Stories & Testimonials',
        content: '"Share your success story from a BNI referral"\n\n- Member Name\n- Business Name\n- Brief testimonial about the referral impact',
        layout: 'bni_white',
        backgroundImage: 'https://images.unsplash.com/photo-1552664730-d307ca884978?w=1920&q=80',
        backgroundColor: '#ffffff'
      }
    ]
  }, */
  {
    id: 'business-pitch',
    name: 'Business Pitch',
    category: 'Business',
    description: '5-slide pitch deck for startups and businesses',
    theme: 'modern',
    thumbnail: 'https://images.unsplash.com/photo-1551434678-e076c223a692?w=400&q=80',
    slides: [
      {
        title: 'Company Name',
        content: '• Your tagline here\n• Presented by [Your Name]',
        layout: 'title_content',
        backgroundImage: 'https://images.unsplash.com/photo-1551434678-e076c223a692?w=1920&q=80'
      },
      {
        title: 'The Problem',
        content: '• What problem are you solving?\n• Who has this problem?\n• How big is the problem?',
        layout: 'title_content',
        backgroundImage: 'https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?w=1920&q=80'
      },
      {
        title: 'Our Solution',
        content: '• How does your product/service solve it?\n• What makes it unique?\n• Key benefits',
        layout: 'title_content',
        backgroundImage: 'https://images.unsplash.com/photo-1460925895917-afdab827c52f?w=1920&q=80'
      },
      {
        title: 'Market Opportunity',
        content: '• Target market size\n• Growth potential\n• Competition analysis',
        layout: 'title_content',
        backgroundImage: 'https://images.unsplash.com/photo-1551288049-bebda4e38f71?w=1920&q=80'
      },
      {
        title: 'Call to Action',
        content: '• What do you want from the audience?\n• Contact information\n• Next steps',
        layout: 'title_content',
        backgroundImage: 'https://images.unsplash.com/photo-1556761175-5973dc0f32e7?w=1920&q=80'
      }
    ]
  },
  {
    id: 'product-launch',
    name: 'Product Launch',
    category: 'Marketing',
    description: 'Announce and showcase your new product',
    theme: 'modern',
    thumbnail: 'https://images.unsplash.com/photo-1460925895917-afdab827c52f?w=400&q=80',
    slides: [
      {
        title: 'Introducing [Product Name]',
        content: '• Revolutionary new solution\n• Launch date: [Date]',
        layout: 'title_content',
        backgroundImage: 'https://images.unsplash.com/photo-1505740420928-5e560c06d30e?w=1920&q=80'
      },
      {
        title: 'Key Features',
        content: '• Feature 1: Description\n• Feature 2: Description\n• Feature 3: Description\n• Feature 4: Description',
        layout: 'title_content',
        backgroundImage: 'https://images.unsplash.com/photo-1526948531399-320e7e40f0ca?w=1920&q=80'
      },
      {
        title: 'Benefits',
        content: '• Save time and money\n• Increase productivity\n• Better results\n• Easy to use',
        layout: 'title_content',
        backgroundImage: 'https://images.unsplash.com/photo-1522071820081-009f0129c71c?w=1920&q=80'
      },
      {
        title: 'Pricing',
        content: '• Starter: $X/month\n• Professional: $Y/month\n• Enterprise: Custom pricing\n• 30-day free trial available',
        layout: 'title_content',
        backgroundImage: 'https://images.unsplash.com/photo-1554224155-8d04cb21cd6c?w=1920&q=80'
      },
      {
        title: 'Get Started Today',
        content: '• Visit: www.yourwebsite.com\n• Email: contact@company.com\n• Phone: (XXX) XXX-XXXX\n• Limited time offer!',
        layout: 'title_content',
        backgroundImage: 'https://images.unsplash.com/photo-1557426272-fc759fdf7a8d?w=1920&q=80'
      }
    ]
  },
  {
    id: 'training-workshop',
    name: 'Training Workshop',
    category: 'Education',
    description: 'Educational workshop or training session',
    theme: 'modern',
    thumbnail: 'https://images.unsplash.com/photo-1524178232363-1fb2b075b655?w=400&q=80',
    slides: [
      {
        title: 'Workshop Title',
        content: '• Instructor: [Your Name]\n• Date: [Date]\n• Duration: [X] hours',
        layout: 'title_content',
        backgroundImage: 'https://images.unsplash.com/photo-1524178232363-1fb2b075b655?w=1920&q=80'
      },
      {
        title: 'Learning Objectives',
        content: '• Master key concepts\n• Apply practical skills\n• Understand best practices\n• Complete hands-on exercises',
        layout: 'title_content',
        backgroundImage: 'https://images.unsplash.com/photo-1516321318423-f06f85e504b3?w=1920&q=80'
      },
      {
        title: 'Agenda',
        content: '• Introduction (15 min)\n• Module 1: Topic (30 min)\n• Module 2: Topic (30 min)\n• Hands-on Practice (45 min)\n• Q&A and Wrap-up (15 min)',
        layout: 'title_content',
        backgroundImage: 'https://images.unsplash.com/photo-1434030216411-0b793f4b4173?w=1920&q=80'
      },
      {
        title: 'Key Takeaways',
        content: '• Important point 1\n• Important point 2\n• Important point 3\n• Resources provided',
        layout: 'title_content',
        backgroundImage: 'https://images.unsplash.com/photo-1513258496099-48168024aec0?w=1920&q=80'
      },
      {
        title: 'Next Steps',
        content: '• Practice what you learned\n• Access additional resources\n• Join our community\n• Contact for support',
        layout: 'title_content',
        backgroundImage: 'https://images.unsplash.com/photo-1498050108023-c5249f4df085?w=1920&q=80'
      }
    ]
  },
  {
    id: 'minimalist-modern',
    name: 'Minimalist Modern',
    category: 'Business',
    description: 'Clean, modern design with bold typography',
    theme: 'modern',
    thumbnail: 'https://images.unsplash.com/photo-1557426272-fc759fdf7a8d?w=400&q=80',
    slides: [
      {
        title: 'YOUR PROJECT TITLE',
        content: 'Subtitle or Tagline Here',
        layout: 'title_content',
        backgroundImage: '',
        backgroundColor: '#1e293b'
      },
      {
        title: 'About',
        content: 'Share your story in a compelling way that resonates with your audience.',
        layout: 'title_content',
        backgroundImage: '',
        backgroundColor: '#f8fafc'
      },
      {
        title: 'Key Features',
        content: '• Feature One\n• Feature Two\n• Feature Three\n• Feature Four',
        layout: 'title_content',
        backgroundImage: '',
        backgroundColor: '#ffffff'
      }
    ]
  },
  {
    id: 'vibrant-gradient',
    name: 'Vibrant Gradient',
    category: 'Creative',
    description: 'Eye-catching gradients and modern aesthetics',
    theme: 'modern',
    thumbnail: 'https://images.unsplash.com/photo-1557683316-973673baf926?w=400&q=80',
    slides: [
      {
        title: 'CREATIVE PRESENTATION',
        content: 'Stand Out From The Crowd',
        layout: 'title_content',
        backgroundImage: 'https://images.unsplash.com/photo-1557683316-973673baf926?w=1920&q=80',
        backgroundColor: '#8b5cf6'
      },
      {
        title: 'Our Vision',
        content: 'Making an impact through innovative solutions and creative thinking.',
        layout: 'title_content',
        backgroundImage: '',
        backgroundColor: '#a855f7'
      },
      {
        title: 'What We Do',
        content: '• Creative Strategy\n• Brand Development\n• Digital Solutions\n• Growth Marketing',
        layout: 'title_content',
        backgroundImage: '',
        backgroundColor: '#c026d3'
      }
    ]
  },
  {
    id: 'elegant-dark',
    name: 'Elegant Dark',
    category: 'Professional',
    description: 'Sophisticated dark theme for professional presentations',
    theme: 'dark',
    thumbnail: 'https://images.unsplash.com/photo-1558403194-611308249627?w=400&q=80',
    slides: [
      {
        title: 'PREMIUM PRESENTATION',
        content: 'Excellence in Every Detail',
        layout: 'title_content',
        backgroundImage: '',
        backgroundColor: '#0f172a'
      },
      {
        title: 'Our Approach',
        content: 'We combine expertise with innovation to deliver exceptional results.',
        layout: 'title_content',
        backgroundImage: '',
        backgroundColor: '#1e293b'
      },
      {
        title: 'Services',
        content: '• Consulting\n• Strategy Development\n• Implementation\n• Ongoing Support',
        layout: 'title_content',
        backgroundImage: '',
        backgroundColor: '#334155'
      }
    ]
  },
  {
    id: 'colorful-blocks',
    name: 'Colorful Blocks',
    category: 'Creative',
    description: 'Vibrant color blocks for energetic presentations',
    theme: 'modern',
    thumbnail: 'https://images.unsplash.com/photo-1561070791-2526d30994b5?w=400&q=80',
    slides: [
      {
        title: 'BOLD & BRIGHT',
        content: 'Make Your Mark',
        layout: 'title_content',
        backgroundImage: '',
        backgroundColor: '#ef4444'
      },
      {
        title: 'Our Story',
        content: 'Building something extraordinary through passion and dedication.',
        layout: 'title_content',
        backgroundImage: '',
        backgroundColor: '#f59e0b'
      },
      {
        title: 'What Sets Us Apart',
        content: '• Unique Approach\n• Proven Results\n• Expert Team\n• Customer First',
        layout: 'title_content',
        backgroundImage: '',
        backgroundColor: '#10b981'
      }
    ]
  },
  {
    id: 'nature-inspired',
    name: 'Nature Inspired',
    category: 'Lifestyle',
    description: 'Organic, natural aesthetic with earthy tones',
    theme: 'modern',
    thumbnail: 'https://images.unsplash.com/photo-1441974231531-c6227db76b6e?w=400&q=80',
    slides: [
      {
        title: 'Natural Beauty',
        content: 'Inspired by Nature',
        layout: 'title_content',
        backgroundImage: 'https://images.unsplash.com/photo-1441974231531-c6227db76b6e?w=1920&q=80',
        backgroundColor: '#16a34a'
      },
      {
        title: 'Our Philosophy',
        content: 'Sustainable, ethical, and mindful in everything we do.',
        layout: 'title_content',
        backgroundImage: 'https://images.unsplash.com/photo-1542601906990-b4d3fb778b09?w=1920&q=80',
        backgroundColor: '#ffffff'
      },
      {
        title: 'Core Values',
        content: '• Sustainability\n• Quality\n• Community\n• Innovation',
        layout: 'title_content',
        backgroundImage: '',
        backgroundColor: '#f0fdf4'
      }
    ]
  },
  {
    id: 'tech-startup',
    name: 'Tech Startup',
    category: 'Technology',
    description: 'Modern tech aesthetic with bold colors',
    theme: 'modern',
    thumbnail: 'https://images.unsplash.com/photo-1519389950473-47ba0277781c?w=400&q=80',
    slides: [
      {
        title: 'THE FUTURE IS NOW',
        content: 'Innovating Tomorrow',
        layout: 'title_content',
        backgroundImage: 'https://images.unsplash.com/photo-1519389950473-47ba0277781c?w=1920&q=80',
        backgroundColor: '#2563eb'
      },
      {
        title: 'Technology That Matters',
        content: 'Building solutions that make a real difference in people\'s lives.',
        layout: 'title_content',
        backgroundImage: '',
        backgroundColor: '#1e40af'
      },
      {
        title: 'Our Platform',
        content: '• AI-Powered\n• Scalable\n• Secure\n• User-Friendly',
        layout: 'title_content',
        backgroundImage: '',
        backgroundColor: '#3b82f6'
      }
    ]
  },
  {
    id: 'corporate-blue',
    name: 'Corporate Blue',
    category: 'Professional',
    description: 'Classic corporate style with professional blue tones',
    theme: 'modern',
    thumbnail: 'https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?w=400&q=80',
    slides: [
      {
        title: 'ANNUAL REPORT 2024',
        content: 'Building Success Together',
        layout: 'title_content',
        backgroundImage: 'https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?w=1920&q=80',
        backgroundColor: '#1e40af'
      },
      {
        title: 'Executive Summary',
        content: 'A year of growth, innovation, and strategic achievements.',
        layout: 'title_content',
        backgroundImage: '',
        backgroundColor: '#ffffff'
      },
      {
        title: 'Key Metrics',
        content: '• Revenue Growth: 45%\n• Market Expansion: 12 Countries\n• Customer Satisfaction: 95%\n• Team Growth: 200+ Members',
        layout: 'title_content',
        backgroundImage: '',
        backgroundColor: '#eff6ff'
      }
    ]
  },
  {
    id: 'artistic-creative',
    name: 'Artistic Creative',
    category: 'Creative',
    description: 'Artistic flair with creative layouts',
    theme: 'modern',
    thumbnail: 'https://images.unsplash.com/photo-1460661419201-fd4cecdf8a8b?w=400&q=80',
    slides: [
      {
        title: 'CREATIVE VISION',
        content: 'Where Art Meets Purpose',
        layout: 'title_content',
        backgroundImage: 'https://images.unsplash.com/photo-1460661419201-fd4cecdf8a8b?w=1920&q=80',
        backgroundColor: '#ec4899'
      },
      {
        title: 'Our Canvas',
        content: 'Every project is an opportunity to create something beautiful and meaningful.',
        layout: 'title_content',
        backgroundImage: '',
        backgroundColor: '#fce7f3'
      },
      {
        title: 'Services',
        content: '• Graphic Design\n• Branding\n• Art Direction\n• Creative Strategy',
        layout: 'title_content',
        backgroundImage: '',
        backgroundColor: '#fdf2f8'
      }
    ]
  },
  {
    id: 'wellness-health',
    name: 'Wellness & Health',
    category: 'Health',
    description: 'Calming, wellness-focused design',
    theme: 'modern',
    thumbnail: 'https://images.unsplash.com/photo-1544367567-0f2fcb009e0b?w=400&q=80',
    slides: [
      {
        title: 'WELLNESS JOURNEY',
        content: 'Mind • Body • Soul',
        layout: 'title_content',
        backgroundImage: 'https://images.unsplash.com/photo-1544367567-0f2fcb009e0b?w=1920&q=80',
        backgroundColor: '#14b8a6'
      },
      {
        title: 'Holistic Approach',
        content: 'Nurturing your complete wellbeing through integrated care and mindful practices.',
        layout: 'title_content',
        backgroundImage: '',
        backgroundColor: '#f0fdfa'
      },
      {
        title: 'Our Programs',
        content: '• Nutrition Guidance\n• Fitness Training\n• Mental Wellness\n• Lifestyle Coaching',
        layout: 'title_content',
        backgroundImage: '',
        backgroundColor: '#ccfbf1'
      }
    ]
  },
  {
    id: 'blank',
    name: 'Blank Canvas',
    category: 'Basic',
    description: 'Start from scratch with a blank slide',
    theme: 'modern',
    thumbnail: 'https://images.unsplash.com/photo-1497032628192-86f99bcd76bc?w=400&q=80',
    slides: [
      {
        title: 'Your Title Here',
        content: 'Click to edit and add your content',
        layout: 'title_content',
        backgroundImage: '',
        backgroundColor: '#ffffff'
      }
    ]
  }
];

// Combine all templates
export const slideTemplates = [...baseTemplates, ...businessSlideTemplates];

export const templateCategories = [
  'All',
  'Networking',
  'Real Estate',
  'Food & Hospitality',
  'Beauty',
  'Health & Wellness',
  'Professional Services',
  'Home Services',
  'Creative Services',
  'Healthcare',
  'Financial Services',
  'Marketing',
  'Business',
  'Professional',
  'Creative',
  'Technology',
  'Lifestyle',
  'Education',
  'Basic'
];
